import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const EmailSettingsNroRedirect = lazy(() =>
  import("@scenes/EmailSettings/EmailSettingsNroRedirect").then((module) => ({
    default: module.EmailSettingsNroRedirect,
  }))
);

export const emailPreferencesNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("email-preferences-pill-menu-option", "Email Preferences"),
  // TODO (DASHI-3996): once the migration is complete, replace this component with the GeneralEmailSettings component
  Component: EmailSettingsNroRedirect,
  componentFeatureFlippers: ["email_preferences_nro_component"],
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => [
    {
      keywords: [t("email-preferences-email-settings", "Email Settings")],
      description: t("previously-email-settings", 'Previously "Email Settings"'),
    },
    {
      keywords: [t("email-preferences-manage-settings", "Manage Settings")],
      description: t("previously-manage-settings", 'Previously in "Manage Settings"'),
    },
    {
      keywords: [
        t("email-preferences-alt-keyword-1", "Sending Configuration"),
        t("email-preferences-alt-keyword-2", "Email Templates"),
        t("email-preferences-alt-keyword-3", "outbound email settings"),
        t("email-preferences-alt-keyword-4", "display name address"),
        t("email-preferences-alt-keyword-5", "reply-to address"),
        t("email-preferences-alt-keyword-6", "bcc address"),
        t("email-preferences-alt-keyword-7", "tracking pixel"),
        t("email-preferences-alt-keyword-8", "email unsubscribe header"),
        t("email-preferences-alt-keyword-9", "Transactional Event Status Postback"),
        t("email-preferences-alt-keyword-10", "Subscription pages"),
        t("email-preferences-alt-keyword-11", "footers"),
        t("email-preferences-alt-keyword-12", "email global style settings"),
        t("email-preferences-alt-keyword-13", "link aliasing settings"),
      ],
    },
  ],
  additionalSearchableFeatures: () => ({}),
};
